export const REQUESTS_CONSTS = {
    GET_REQUESTS: "GET_REQUESTS",
    DELETE_REQUEST_BY_ID: "DELETE_REQUEST_BY_ID",
};
